import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { DepField, makeFiltersBuilder } from "@/features/FilterTable/utils";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { createCurrencyOption } from "@/hooks/useCurrencyOption";
import { z } from "zod";

const filterC8TimeSeriesSchema = z.object({
  c8_static_datum_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  isin_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  currency_contains: z.string().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  create_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  create_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterC8TimeSeriesSchema = z.infer<typeof filterC8TimeSeriesSchema>;

const assetDepFields: readonly DepField<FilterC8TimeSeriesSchema>[] = [
  {
    name: "c8_static_datum_name_contains",
    key: "id",
    extract: "id",
    bucket: "equals",
  },
  { name: "isin_contains", key: "isin", extract: "text", bucket: "equals" },
];

const fields: Field[] = [
  {
    name: "c8_static_datum_name_contains",
    label: `Actif`,
    type: "asyncAutocomplete",
    base_url: "c8/c8_static_data",
    id_column: "c8_static_datum_id",
    column_name: "name",
    col_span: 2,
    filters: makeFiltersBuilder<FilterC8TimeSeriesSchema>(
      assetDepFields,
      "c8_static_datum_name_contains",
    ),
  },
  {
    name: "isin_contains",
    label: `ISIN`,
    type: "asyncAutocomplete",
    base_url: "c8/c8_static_data",
    id_column: "c8_static_datum_id",
    column_name: "isin",
    filters: makeFiltersBuilder<FilterC8TimeSeriesSchema>(
      assetDepFields,
      "isin_contains",
    ),
  },
  {
    name: "currency_contains",
    label: `Devise`,
    type: "autocomplete",
    options: createCurrencyOption(),
  },
  {
    name: "date",
    type: "dateRange",
    label: "Date de valeur",
    from: { name: "date_from" },
    to: { name: "date_to" },
    col_span: 2,
  },
  {
    name: "create",
    type: "dateRange",
    label: "Date de création",
    from: { name: "create_from" },
    to: { name: "create_to" },
    col_span: 2,
  },
];

export function FilterC8TimeSeries() {
  return (
    <FilterTable
      schema={filterC8TimeSeriesSchema}
      client="c8"
      tableName="c8_time_series"
      fields={fields}
      columns={2}
    />
  );
}
